import { Injectable } from '@angular/core';
import { DialogAlertComponent } from './dialog-alert/dialog-alert.component';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { DialogPromptComponent } from './dialog-prompt/dialog-prompt.component';
import { DialogSpinnerComponent } from './dialog-spinner/dialog-spinner.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
	providedIn: 'root'
})
export class DialogService {
	constructor(private dialog: MatDialog) {}

	closeDialog(dialogRef: MatDialogRef<any>): void {
		dialogRef.close();
	}

	showAlert(
		title: string,
		message: string,
		state: 'default' | 'success' | 'warning' | 'error' = 'default',
		handle?: () => void
	): MatDialogRef<DialogAlertComponent> {
		const dialogRef = this.dialog.open(DialogAlertComponent, {
			autoFocus: false,
			data: { title, message, state }
		});

		if (handle) {
			dialogRef.afterClosed().subscribe(() => {
				handle();
			});
		}
		return dialogRef;
	}

	showConfirm(
		title: string,
		message: string,
		state: 'default' | 'success' | 'warning' | 'error' = 'default',
		handle: (confirmed: boolean) => void
	): MatDialogRef<DialogConfirmComponent> {
		const dialogRef = this.dialog.open(DialogConfirmComponent, {
			autoFocus: false,
			data: { title, message, state }
		});
		dialogRef.afterClosed().subscribe((confirmed: boolean) => {
			handle(confirmed);
		});

		return dialogRef;
	}

	showPrompt(
		title: string,
		message: string,
		state: 'default' | 'success' | 'warning' | 'error' = 'default',
		handle: (userInput: string) => void
	): MatDialogRef<DialogPromptComponent> {
		const dialogRef = this.dialog.open(DialogPromptComponent, {
			data: { title, message, state }
		});
		dialogRef.afterClosed().subscribe((userInput: string) => {
			handle(userInput);
		});

		return dialogRef;
	}

	// Spinner logic - - - - -

	private spinnerRef: MatDialogRef<DialogSpinnerComponent>;
	private requests: { [urlRef: string]: string } = {};

	showSpinner(urlRef: string, request: string): void {
		// Check if the resource is already in the queue.
		if (this.requests[urlRef]) {
			return;
		}

		this.requests[urlRef] = request;

		if (!this.spinnerRef) {
			this.spinnerRef = this.dialog.open(DialogSpinnerComponent, {
				disableClose: true
			});
		}

		this.spinnerRef.componentInstance.requests = this.getResourcesArray();
	}

	closeSpinner(urlRef: string): void {
		if (!this.requests[urlRef]) {
			return;
		}

		delete this.requests[urlRef];

		if (Object.keys(this.requests).length === 0 && this.spinnerRef) {
			this.spinnerRef.close();
			this.spinnerRef = null;
		} else {
			this.spinnerRef.componentInstance.requests = this.getResourcesArray();
		}
	}

	private getResourcesArray(): string[] {
		return Object.values(this.requests);
	}
}
